export interface LockSelectionLabels {
  lock: string
  unlock: string
  disabled: string
}

export const DEFAULT_LOCK_SELECTION_LABELS: LockSelectionLabels = {
  lock: 'Lock selection',
  unlock: 'Unlock selection',
  disabled: 'Select rows to lock',
}
